import * as yup from 'yup'
import { isNull, isUndefined, isEmpty } from './fns'

export const isDecimal = (value) => {
  const regExp = new RegExp(`^[-+]?([0-9]+)?(\\.[0-9]{1,})?$`)

  return regExp.test(value)
}

// Using custom test method
export function decimal(fieldName, message) {
  return this.test('decimal', message, function (value) {
    const { path, createError } = this

    if (isNull(value) || isUndefined(value) || isEmpty(value)) {
      return createError({ path, message: message || `${fieldName} is a required field.` })
    }

    if (isNaN(value)) {
      return createError({ path, message: message || `${fieldName} field must be a number.` })
    }

    if (!isDecimal(value)) {
      return createError({
        path,
        message: 'Please enter a valid decimal number.',
      })
    }

    return true
  })
}

export function integer(fieldName, message) {
  return this.test('integer', message, function (value) {
    const { path, createError } = this

    if (isNull(value) || isUndefined(value) || isEmpty(value)) {
      return createError({ path, message: message || `${fieldName} is a required field.` })
    }

    if (isNaN(value)) {
      return createError({ path, message: message || `${fieldName} field must be a number.` })
    }

    if (!String(value).match(/^-?\d+$/)) {
      return createError({
        path,
        message: message || `${fieldName} field only accepts whole numbers.`,
      })
    }

    return true
  })
}

export function range(min = 0, max = 99, message) {
  return this.test('range', message, function (value) {
    const { path, createError } = this

    if (value < min || value > max) {
      return createError({
        path,
        message:
          message ||
          // `Please enter a value between ${numberWithCommas(min)} and ${numberWithCommas(max)}.`,
          `Please enter a value between ${min} and ${max}.`,
      })
    }

    return true
  })
}

export function uid(fieldName = 'UID', message) {
  return this.test('uid', message, function (value) {
    const { path, createError } = this

    if (!value) {
      return createError({
        path,
        message: message || `${fieldName} is a required field.`,
      })
    } else if (value.length > 15) {
      // Min and max should be dynamic in the future
      return createError({
        path,
        message: message || `${fieldName} cannot have more than 15 characters.`,
      })
    }

    return true
  })
}

export const FeedbackSchema = yup.object({
  summary: yup.string().required('Required'),
  email: yup.string().required('Required').email('Please enter a correct email address'),
  description: yup.string().required('Required'),
})
